import { render, staticRenderFns } from "./GroupPlaylists.vue?vue&type=template&id=0d4e8e5d&"
import script from "./GroupPlaylists.vue?vue&type=script&lang=js&"
export * from "./GroupPlaylists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QIcon,QMenu,QItem,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QExpansionItem,QItemSection,QIcon,QMenu,QItem,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
